import * as React from "react"
const buttonVariants = (variants = {}) => {
    const baseClasses =
        "inline-flex items-center justify-center gap-2 whitespace-nowrap text-white rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0"

    const variantClasses = {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive:
            "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
            "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
            "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
    }

    const sizeClasses = {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
    }

    return [
        baseClasses,
        variantClasses[variants.variant || "default"],
        sizeClasses[variants.size || "default"],
        variants.className,
    ]
        .filter(Boolean)
        .join(" ")
}

const Button = React.forwardRef(({ className, variant, size, ...props }, ref) => {
    const classNames = buttonVariants({ variant, size, className })
    return (
        <button
            className={classNames}
            ref={ref}
            {...props}
        />
    )
})

Button.displayName = "Button"

export { Button, buttonVariants }
